import * as React from 'react';
import {
    ButtonDropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from 'reactstrap';
import {
    AddActivityStreamProps,
    AthleteProps,
    CustomStreamType,
    SaveAthleteOptionsProps,
    StravaStreamType
} from '../../types';
import './ActivityChart.scss';

// tslint:disable-next-line:no-submodule-imports
import * as faPlus from '@fortawesome/fontawesome-free-solid/faPlus';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { shallowEqual } from 'recompose';
import withToggleState, { ToggleStateProps } from '../../../withToggleState';

type AddChartDropdownProps = { id: string } & AddActivityStreamProps &
    AthleteProps &
    SaveAthleteOptionsProps;

class AddChartDropdown extends React.Component<
    AddChartDropdownProps & ToggleStateProps
> {
    constructor(props: AddChartDropdownProps & ToggleStateProps) {
        super(props);
        this.handleAddStreamType = this.handleAddStreamType.bind(this);
    }

    public shouldComponentUpdate(
        nextProps: AddChartDropdownProps & ToggleStateProps,
        nextState: { dropdownOpen: boolean }
    ) {
        return (
            !shallowEqual(this.props, nextProps) ||
            !shallowEqual(this.state, nextState)
        );
    }

    public render() {
        const {
            loggedInUser,
            activityStreamInfoList,
            active,
            toggle
        } = this.props;

        const athlete =
            (loggedInUser && loggedInUser.user && loggedInUser.user.athlete) ||
            undefined;
        const types = (athlete && athlete.activityStreamTypes) || [];

        const info =
            (activityStreamInfoList &&
                activityStreamInfoList.activityStreamInfoList) ||
            [];

        return (
            <ButtonDropdown
                isOpen={active}
                toggle={toggle}
                size="sm"
                disabled={!info.length}
            >
                <DropdownToggle
                    id="add-chart-dropdown"
                    color="primary"
                    caret={true}
                >
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    Add a chart
                </DropdownToggle>
                <DropdownMenu>
                    {info.length ? (
                        info
                            .filter(
                                t =>
                                    t.type !== StravaStreamType.distance &&
                                    t.type !== StravaStreamType.time
                            )
                            .map(t => (
                                <DropdownItem
                                    // tslint:disable-next-line:jsx-no-lambda
                                    onClick={() =>
                                        this.handleAddStreamType(t.type)
                                    }
                                    key={t.type}
                                    disabled={types.indexOf(t.type) >= 0}
                                >
                                    {t.friendlyName}
                                </DropdownItem>
                            ))
                    ) : (
                        <DropdownItem disabled={true} />
                    )}
                </DropdownMenu>
            </ButtonDropdown>
        );
    }

    private async handleAddStreamType(
        streamType: StravaStreamType | CustomStreamType
    ) {
        const { id, addActivityStream } = this.props;

        if (!addActivityStream) {
            throw new Error('No add activity stream callback provided');
        }
        // then add the stream to the list
        await addActivityStream(streamType, id);
    }
}
export default withToggleState<AddChartDropdownProps>()(AddChartDropdown);



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityScene/ActivityChart/AddChartDropdown.tsx